/** Resolve logged-in user fields from context or localStorage (login API shape). */
export function getStoredUser(contextUser) {
  if (contextUser && typeof contextUser === "object") return contextUser;
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getUserDisplayName(user) {
  const u = getStoredUser(user);
  if (!u) return "—";
  const full = u.fullName ?? u.FullName;
  if (full) return full;
  const first = u.firstName ?? u.FirstName ?? u.name ?? u.Name ?? "";
  const last = u.lastName ?? u.LastName ?? u.preName ?? u.PreName ?? "";
  const joined = [first, last].filter(Boolean).join(" ");
  return joined || u.username || u.Username || u.userName || u.email || u.Email || "—";
}

export function getUserEmail(user) {
  const u = getStoredUser(user);
  if (!u) return "—";
  return u.userName ?? u.UserName ?? u.email ?? u.Email ?? u.username ?? u.Username ?? "—";
}
